<template>
  <div class="main">
    <header class="panel-heading">
      <h3 class="panel-title">宿舍資訊暨設備教育訓練作答</h3>
    </header>

    <section class="panel panel-default">
      <div class="panel-body" v-if="loadingModule">
        <div class="text-center"><i class="fa fa-spinner fa-spin"></i> 載入中...</div>
      </div>

      <div class="panel-body" v-else-if="!moduleInfo">
        <div class="alert alert-danger">查無教育訓練資料。</div>
      </div>

      <div class="panel-body" v-else>
        <div class="row form-group">
          <div class="col-md-12">
            <h4>{{ moduleInfo.title }}</h4>
            <p style="white-space: pre-line;">{{ moduleInfo.description }}</p>
          </div>
        </div>

        <div class="row form-group" v-if="embedVideoUrl">
          <div class="col-md-12 video-wrapper">
            <iframe :src="embedVideoUrl" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>

        <div class="row form-group" v-else>
          <div class="col-md-12">
            <a :href="moduleInfo.videoUrl" target="_blank" class="btn btn-default">開啟影片連結</a>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4">
            <strong>及格分數：</strong>{{ moduleInfo.passScore }} 分
          </div>
          <div class="col-md-8 text-right" v-if="latestResult">
            <span :class="latestResult.passed === 'Y' ? 'label label-success' : 'label label-danger'">
              最新結果：{{ latestResult.passed === 'Y' ? '已通過' : '未通過' }} / {{ latestResult.score }} 分
            </span>
          </div>
        </div>

        <div class="row form-group" v-if="!hasStarted">
          <div class="col-md-12 text-center">
            <a href="javascript:;" class="btn btn-primary" @click="startAttempt">開始作答</a>
            <a href="javascript:;" class="btn btn-default" style="margin-left: 8px;" @click="goBack">返回</a>
          </div>
        </div>

        <template v-if="hasStarted">
          <hr />
          <div class="question-block" v-for="(question, index) in questions" :key="question.id">
            <h4>{{ index + 1 }}. {{ question.questionText }} <small>({{ question.score }} 分)</small></h4>

            <div v-if="isChoiceQuestion(question)">
              <div v-for="option in question.options" :key="option.id" class="answer-row">
                <label v-if="question.questionType !== 'multipleChoice'" class="radio-inline">
                  <input type="radio" :name="`question-${question.id}`" :value="option.id" v-model="question.singleOptionId" /> {{ option.optionText }}
                </label>
                <label v-else class="checkbox-inline">
                  <input type="checkbox" :value="option.id" v-model="question.selectedOptionIds" /> {{ option.optionText }}
                </label>
              </div>
            </div>

            <div v-else-if="question.questionType === 'singleLineText'">
              <input v-model="question.answerText" type="text" class="form-control" />
            </div>

            <div v-else>
              <textarea v-model="question.answerText" rows="4" class="form-control"></textarea>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-12 text-center">
              <a href="javascript:;" class="btn btn-primary" @click="submitAttempt">送出作答</a>
              <a href="javascript:;" class="btn btn-default" style="margin-left: 8px;" @click="goBack">返回</a>
            </div>
          </div>
        </template>

        <div class="alert" :class="result.passed === 'Y' ? 'alert-success' : 'alert-danger'" v-if="result">
          作答完成，得分 {{ result.score }} 分，{{ result.passed === 'Y' ? '已通過' : '未通過' }}。
          <a v-if="result.passed !== 'Y'" href="javascript:;" class="alert-link" @click="restartAttempt">重新作答</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingModule: false,
      moduleId: '',
      moduleInfo: null,
      latestResult: null,
      hasStarted: false,
      attemptId: '',
      questions: [],
      result: null
    };
  },
  computed: {
    embedVideoUrl() {
      if (!this.moduleInfo || !this.moduleInfo.videoUrl) {
        return '';
      }
      const url = this.moduleInfo.videoUrl;
      if (url.indexOf('youtube.com/watch') >= 0) {
        const videoId = (url.split('v=')[1] || '').split('&')[0];
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
      }
      if (url.indexOf('youtu.be/') >= 0) {
        const videoId = url.split('youtu.be/')[1].split('?')[0];
        return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
      }
      return '';
    }
  },
  created() {
    const storeData = this.getStore(this.$route.name);
    if (!storeData) {
      this.goBack();
      return;
    }
    const parsed = JSON.parse(storeData);
    this.moduleId = parsed.id;
    this.loadModule();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'stay.training' });
    },
    loadModule() {
      this.loadingModule = true;
      this.$axios.get(`/api/DormitoryTraining/module/${this.moduleId}`).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '載入失敗');
          this.moduleInfo = null;
          return;
        }
        this.moduleInfo = resp.data.data;
        this.latestResult = resp.data.data.latestResult || null;
      }).finally(() => {
        this.loadingModule = false;
      });
    },
    startAttempt() {
      this.$axios.post(`/api/DormitoryTraining/module/${this.moduleId}/start`).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '無法開始作答');
          return;
        }
        this.attemptId = resp.data.data.attemptId;
        this.result = null;
        this.hasStarted = true;
        this.questions = (resp.data.data.questions || []).map(question => ({
          ...question,
          singleOptionId: '',
          selectedOptionIds: [],
          answerText: ''
        }));
      });
    },
    restartAttempt() {
      this.startAttempt();
    },
    isChoiceQuestion(question) {
      return ['trueFalse', 'singleChoice', 'multipleChoice'].includes(question.questionType);
    },
    validateAnswers() {
      for (const question of this.questions) {
        if (question.questionType === 'multipleChoice' && question.selectedOptionIds.length === 0) {
          return false;
        }
        if (['trueFalse', 'singleChoice'].includes(question.questionType) && !question.singleOptionId) {
          return false;
        }
        if (['singleLineText', 'multiLineText'].includes(question.questionType) && !question.answerText) {
          return false;
        }
      }
      return true;
    },
    buildSubmitPayload() {
      return {
        answers: this.questions.map(question => ({
          questionId: question.id,
          selectedOptionIds: question.questionType === 'multipleChoice'
            ? question.selectedOptionIds
            : (question.singleOptionId ? [question.singleOptionId] : []),
          answerText: question.answerText
        }))
      };
    },
    submitAttempt() {
      if (!this.validateAnswers()) {
        bootbox.alert('每一題都必須作答。');
        return;
      }
      this.$axios.post(`/api/DormitoryTraining/attempt/${this.attemptId}/submit`, this.buildSubmitPayload()).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '送出失敗');
          return;
        }
        this.result = resp.data.data;
        this.latestResult = resp.data.data;
        this.hasStarted = false;
      });
    }
  }
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.question-block {
  margin-bottom: 24px;
}

.answer-row {
  margin-bottom: 8px;
}
</style>